/* eslint-disable */
const getters = {
  getComplaint(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
